export default __webpack_public_path__ + "static/media/highlight-9-new.18d0b829.png";